import { useEffect, useState, useLayoutEffect } from "react";
import "./App.scss";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import About from "./components/About";
import BestSellers from "./components/BestSellers";
import MyGallery from "./components/MyGallery";
import Services from "./components/Services";
import ContactUs from "./components/ContactUs";
import * as fbq from "./configs/fpixel";

// const bg = [
//   "https://main.mobile.doss.co.id/storage/uploads/2022/08/papershoot-indonesia-main-background-04.webp",
//   "https://main.mobile.doss.co.id/storage/uploads/2022/08/papershoot-indonesia-main-background-06.webp",
//   "https://main.mobile.doss.co.id/storage/uploads/2022/08/papershoot-indonesia-main-background-07.webp",
// ]
const bg = [
  "https://main.mobile.doss.co.id/storage/uploads/2022/08/papershoot-indonesia-white-background-06.webp",
];

const bg2 = [
  "https://main.mobile.doss.co.id/storage/uploads/2022/08/papershoot-indonesia-vertikal-background-07.webp",
];

// const bg2 = [
//   "https://main.mobile.doss.co.id/storage/uploads/2022/08/papershoot-indonesia-vertikal-background-06.webp",
//   "https://main.mobile.doss.co.id/storage/uploads/2022/08/papershoot-indonesia-vertikal-background-06.webp",
// ];

function App() {
  const [index, setIndex] = useState(0);
  const [size, setSize] = useState([0, 0]);

  function useWindowSize() {
    useLayoutEffect(() => {
      function updateSize() {
        setSize([window.innerWidth, window.innerHeight]);
      }
      window.addEventListener("resize", updateSize);
      updateSize();
      return () => window.removeEventListener("resize", updateSize);
    }, []);
    return size;
  }

  useWindowSize();

  const changeBackgroundImage = () => {
    let max = bg.length;
    if (index + 1 < max) {
      setIndex(index + 1);
    } else {
      setIndex(0);
    }
  };

  useEffect(() => {
    const timeout = setInterval(() => changeBackgroundImage(), 5000);

    return () => {
      clearInterval(timeout);
    };
  });

  useEffect(() => {
    fbq.pageview();
  }, []);

  window.scroll(function () {
    var scrolledY = window.scrollTo(0, 0);
    document.getElementsByClassName(
      "content-wrapper"
    ).style.backgroundPosition = "left " + scrolledY + "px";
  });

  return (
    <div
      className="content-wrapper"
      // style={{
      //   // backgroundImage: `url(${`${size[0] > 572 ? bg[index] : bg2[index]}`})`,
      //   backgroundImage: `url(${`${size[0] > 572 ? bg[0] : bg2[0]}`})`,
      //   backgroundRepeat: "no-repeat",
      //   backgroundSize: "100% auto",
      // }}
    >
      <img
        src={size[0] > 572 ? bg[0] : bg2[0]}
        alt="bg papershoot"
        className="bg-fixed"
        style={{
          height: size[0] > 572 ? "100%" : "auto",
          objectFit: size[0] > 572 ? "cover" : "contain",
        }}
      />
      <Navbar />
      <Hero />;
      <MyGallery />
      <div style={{ height: "4.5rem" }}></div>
      <BestSellers />
      <div style={{ height: "4.5rem" }}></div>
      <About />
      {/* <div style={{ height: "4.5rem" }}></div>
      <Services /> */}
      <div style={{ height: "4.5rem" }}></div>
      <ContactUs />
      <div style={{ height: "4.5rem" }}></div>
    </div>
  );
}

export default App;
